import { render, staticRenderFns } from "./STextArea.vue?vue&type=template&id=2026ea82"
import script from "./STextArea.vue?vue&type=script&lang=js"
export * from "./STextArea.vue?vue&type=script&lang=js"
import style0 from "./STextArea.vue?vue&type=style&index=0&id=2026ea82&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports